export default __webpack_public_path__ + "static/media/shohag1.0e3632e8.png";